/** Optional body fields for payment-session create (ahead of nsdk publish). */
export type PaymentSessionAnalyticsInput = {
  openpanelDeviceId?: string;
  paymentChannel?: string;
};

export const paymentSessionAnalyticsBody = ({
  openpanelDeviceId,
  paymentChannel
}: PaymentSessionAnalyticsInput): PaymentSessionAnalyticsInput => ({
  ...(openpanelDeviceId ? { openpanelDeviceId } : {}),
  ...(paymentChannel ? { paymentChannel } : {})
});
